export interface JobTemplate {
  id: string; // UUID
  companyId: string;
  recruiterId: string;
  userId: string;

  postedBy: string;
  jobTittle: string;
  jobDescription: string;
  jobSummarySlug: string;
   jobSummaryTitle: string;
  roleLevel: string;
  miniExperience: string;
  maxExperience: string;
  // requiredOwnershipLevel: string;
  requiredOwnerShipLevel: string[];

  requiredTeamSize: string;

  requiredTechSkills: string[];
  requiredDomain: string[];
  minBudgetHandled: string;

  expectedImpactLevel: string[];

  location: string[];
  workType: string;
  noticePeriodDays: number;
  compensationOffer: number;

  jobStatus: boolean;

  createdAt: string; // ISO string
  updatedAt: string; // ISO string

}


export const initialJobTemplate: JobTemplate = {
  id: "",
  companyId: "",
  recruiterId: "",
  userId: "",

  postedBy: "",
  jobTittle: "",
  jobDescription: "",
  jobSummarySlug: "",
  jobSummaryTitle: "",

  roleLevel: "",
  miniExperience: "",
  maxExperience: "",
  requiredOwnerShipLevel: [],
  requiredTeamSize: "",

  requiredTechSkills: [],
  requiredDomain: [],
  minBudgetHandled: "",

  expectedImpactLevel: [],

  location: [],
  workType: "",
  noticePeriodDays: 0,
  compensationOffer: 0,

  jobStatus: false,

  createdAt: "",
  updatedAt: "",
};


export interface JobTemplateRequest {
  id: string; // UUID
  companyId: string;
  recruiterId: string;
  userId: string;

  postedBy: string;
  jobTittle: string;
  jobDescription: string;
  jobSummarySlug: string;
  jobSummaryTitle: string;

  roleLevel: string;
  miniExperience: string;
  maxExperience: string;
  requiredOwnerShipLevel: string[];
  requiredTeamSize: string;

  requiredTechSkills: string[];
  requiredDomain: string[];
  minBudgetHandled: string;

  expectedImpactLevel: string[];

  location: string[];
  workType: string;
  noticePeriodDays: number;
  compensationOffer: number;

  jobStatus: boolean;

}


export interface JobTemplateResponse {
  id: string; // UUID
  companyId: string;
  recruiterId: string;
  userId: string;

  postedBy: string;
  jobTittle: string;
  jobDescription: string;
  jobSummarySlug: string;
  jobSummaryTitle: string;

  roleLevel: string;
  miniExperience: string;
  maxExperience: string;
  requiredOwnerShipLevel: string[];
  requiredTeamSize: string;

  requiredTechSkills: string[];
  requiredDomain: string[];
  minBudgetHandled: string;

  expectedImpactLevel: string[];

  location: string[];
  workType: string;
  noticePeriodDays: number;
  compensationOffer: number;

  jobStatus: boolean;

  createdAt: string; // ISO string
  updatedAt: string; // ISO string
}

/**
 * Aggregate counts for the company job-template listing.
 */
export interface JobTemplateStats {
  total: number;
  active: number;
  inactive: number;
  mine: number;
}